import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import {
  CreateOrganizationManagedAdNetworkDto,
  OrganizationManagedAdNetworkDto,
  UpdateOrganizationManagedAdNetworkDto,
} from "../dto/OrganizationManagedAdNetworkDto";
import { OrganizationPublicId, UUIDString } from "../Types";

export class OrganizationManagedAdNetworkController {
  constructor(private axios: AxiosInstance) {}

  public getAllManagedAdNetworks = async (
    organizationId: OrganizationPublicId,
  ): Promise<OrganizationManagedAdNetworkDto[]> => {
    const url = Helpers.organization.managedAdNetworks.root(organizationId);
    const response = await this.axios.get<OrganizationManagedAdNetworkDto[]>(url);
    return response.data;
  };

  public getNetworksByManager = async (
    organizationId: OrganizationPublicId,
    managerId: number,
  ): Promise<OrganizationManagedAdNetworkDto[]> => {
    const url = Helpers.organization.managedAdNetworks.byManager(organizationId, managerId);
    const response = await this.axios.get<OrganizationManagedAdNetworkDto[]>(url);
    return response.data;
  };

  public getManagersByNetwork = async (
    organizationId: OrganizationPublicId,
    networkId: number,
  ): Promise<OrganizationManagedAdNetworkDto[]> => {
    const url = Helpers.organization.managedAdNetworks.byNetwork(organizationId, networkId);
    const response = await this.axios.get<OrganizationManagedAdNetworkDto[]>(url);
    return response.data;
  };

  public createManagedAdNetwork = async (
    organizationId: OrganizationPublicId,
    dto: CreateOrganizationManagedAdNetworkDto,
  ): Promise<OrganizationManagedAdNetworkDto> => {
    const url = Helpers.organization.managedAdNetworks.root(organizationId);
    const response = await this.axios.post<OrganizationManagedAdNetworkDto>(url, dto);
    return response.data;
  };

  public updateManagedAdNetwork = async (
    organizationId: OrganizationPublicId,
    managedAdNetworkId: UUIDString,
    dto: UpdateOrganizationManagedAdNetworkDto,
  ): Promise<OrganizationManagedAdNetworkDto> => {
    const url = Helpers.organization.managedAdNetworks.specific(organizationId, managedAdNetworkId);
    const response = await this.axios.put<OrganizationManagedAdNetworkDto>(url, dto);
    return response.data;
  };

  public deleteManagedAdNetwork = async (
    organizationId: OrganizationPublicId,
    managedAdNetworkId: UUIDString,
  ): Promise<void> => {
    const url = Helpers.organization.managedAdNetworks.specific(organizationId, managedAdNetworkId);
    await this.axios.delete<void>(url);
  };

  public deleteManagedAdNetworkByIds = async (
    organizationId: OrganizationPublicId,
    managerId: number,
    networkId: number,
  ): Promise<void> => {
    const url = Helpers.organization.managedAdNetworks.byManagerAndNetwork(
      organizationId,
      managerId,
      networkId,
    );
    await this.axios.delete<void>(url);
  };
}
